import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import FunFact from '../FunFact';
import PageHeading from '../PageHeading';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';

const funfaceData = [
  {
    title: 'Successful Projects',
    factNumber: '150+',
  },
  {
    title: 'Satisfied Clients',
    factNumber: '80+',
  },
  {
    title: 'Expert Developers',
    factNumber: '25+',
  },
  {
    title: 'Years of Experience',
    factNumber: '8+',
  },
];

export default function AboutPage() {
  pageTitle('About');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* Start Page Heading Section */}
      <PageHeading
        title="About Us"
        bgSrc="images/about_hero_bg.jpeg"
        pageLinkText="About Us"
      />
      {/* End Page Heading Section */}

      {/* Start About Section */}
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-7">
            <SectionHeading
              title="Who We Are"
              subtitle="About Us"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">
                We design and build real-world digital products — not concepts, not demos.
                Our team specializes in developing scalable web platforms, mobile applications,
                and enterprise systems that are actively used by businesses and thousands of end users.
              </p>
              <Spacing lg="15" md="15" />
              <p className="cs-m0">
                We work across multiple industries, including mobility, e-commerce, booking systems,
                payment processing, logistics, government platforms, and large-scale corporate solutions.
              </p>
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="40" />
            </SectionHeading>
          </Div>
          <Div className="col-lg-5 offset-xl-2">
            <img
              src="/images/about_img_1.jpeg"
              alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="col-lg-7">
            <img
              src="/images/about_img_2.jpeg"
              alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="col-lg-5">
            <img
              src="/images/about_img_3.jpeg"
              alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
        </Div>
      </Div>
      <Spacing lg="75" md="55" />
      {/* End About Section */}

      {/* Start Fun Fact Section */}
      <Div className="container">
        <FunFact
          title="Why TUR DER HOFFNUNG"
          subtitle="We focus on transparent service, reliable payment handling, and customer-first merchant operations."
          data={funfaceData}
        />
      </Div>
      {/* End Fun Fact Section */}

      {/* Start What We Do Section */}
      <Spacing lg="100" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-image_layer cs-style1">
              <Div className="cs-image_layer_in">
                <img
                  src="/images/about_img_4.jpeg"
                  alt="About"
                  className="w-100 cs-radius_15"
                />
              </Div>
            </Div>
            <Spacing lg="0" md="40" />
          </Div>
          <Div className="col-xl-5 offset-xl-1 col-lg-6">
            <SectionHeading
              title="What We Do"
              subtitle="Our Services"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">
                We provide end-to-end product development, covering the full lifecycle
                from architecture to deployment and long-term support.
              </p>
              <Spacing lg="15" md="15" />
              <ul className="cs-mp0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                {[
                  'Product architecture & system design',
                  'Web and mobile application development',
                  'High-load backend systems',
                  'Payment, billing, and processing integrations',
                  'Admin panels, dashboards, and reporting systems',
                  'API integrations and third-party services',
                  'Deployment, scaling, and long-term support',
                ].map((item, i) => (
                  <li key={i} style={{ marginBottom: 8, paddingLeft: 15, position: 'relative' }}>
                    <span style={{ position: 'absolute', left: 0, color: '#ff4a17' }}>•</span>
                    {item}
                  </li>
                ))}
              </ul>
              <Spacing lg="15" md="15" />
              <p className="cs-m0">
                Our focus is on stability, performance, and real business usage — not experimental prototypes.
              </p>
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="0" />
            </SectionHeading>
          </Div>
        </Div>
      </Div>
      {/* End What We Do Section */}

      {/* Start How We Work Section */}
      <Spacing lg="100" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 offset-xl-1 col-lg-6 order-lg-2">
            <SectionHeading
              title="How We Work"
              subtitle="Our Approach"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">
                We approach every project as a long-term system, not a one-time delivery.
              </p>
              <Spacing lg="15" md="15" />
              <ul className="cs-mp0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                {[
                  'Clear technical architecture from day one',
                  'Clean, maintainable, and documented code',
                  'Security and performance as core principles',
                  'Transparent communication with clients',
                  'Solutions built to scale, not to be rewritten later',
                ].map((item, i) => (
                  <li key={i} style={{ marginBottom: 8, paddingLeft: 15, position: 'relative' }}>
                    <span style={{ position: 'absolute', left: 0, color: '#ff4a17' }}>•</span>
                    {item}
                  </li>
                ))}
              </ul>
              <Spacing lg="15" md="15" />
              <p className="cs-m0">
                Many of the systems we have delivered operate 24/7, handle financial transactions,
                or support large user bases.
              </p>
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="0" />
            </SectionHeading>
          </Div>
          <Div className="col-xl-5 col-lg-6 order-lg-1">
            <Div className="cs-image_layer cs-style1">
              <Div className="cs-image_layer_in">
                <img
                  src="/images/about_img_1.jpeg"
                  alt="How We Work"
                  className="w-100 cs-radius_15"
                />
              </Div>
            </Div>
            <Spacing lg="0" md="40" />
          </Div>
        </Div>
      </Div>
      {/* End How We Work Section */}

      {/* Start Our Experience Section */}
      <Spacing lg="100" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-image_layer cs-style1">
              <Div className="cs-image_layer_in">
                <img
                  src="/images/about_img_2.jpeg"
                  alt="Our Experience"
                  className="w-100 cs-radius_15"
                />
              </Div>
            </Div>
            <Spacing lg="0" md="40" />
          </Div>
          <Div className="col-xl-5 offset-xl-1 col-lg-6">
            <SectionHeading
              title="Our Experience"
              subtitle="Portfolio"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">Our portfolio includes:</p>
              <Spacing lg="15" md="15" />
              <ul className="cs-mp0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                {[
                  'Taxi & mobility platforms (rider & driver apps)',
                  'E-commerce and marketplace systems',
                  'Reservation and booking platforms',
                  'Enterprise management systems',
                  'Property, facility, and maintenance platforms',
                  'Automotive and spare-parts platforms',
                  'Travel, visa, and information systems',
                ].map((item, i) => (
                  <li key={i} style={{ marginBottom: 8, paddingLeft: 15, position: 'relative' }}>
                    <span style={{ position: 'absolute', left: 0, color: '#ff4a17' }}>•</span>
                    {item}
                  </li>
                ))}
              </ul>
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="0" />
            </SectionHeading>
          </Div>
        </Div>
      </Div>
      {/* End Our Experience Section */}

      {/* Start Why Choose Us Section */}
      <Spacing lg="100" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 offset-xl-1 col-lg-6 order-lg-2">
            <SectionHeading
              title="Why Clients Choose Us"
              subtitle="Our Strengths"
            >
              <Spacing lg="30" md="20" />
              <ul className="cs-mp0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                {[
                  'We build production-ready systems, not samples',
                  'We understand both technology and business logic',
                  'We have experience with complex integrations',
                  'We deliver solutions that are already proven in real use',
                ].map((item, i) => (
                  <li key={i} style={{ marginBottom: 8, paddingLeft: 15, position: 'relative' }}>
                    <span style={{ position: 'absolute', left: 0, color: '#ff4a17' }}>•</span>
                    {item}
                  </li>
                ))}
              </ul>
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="0" />
            </SectionHeading>
          </Div>
          <Div className="col-xl-5 col-lg-6 order-lg-1">
            <Div className="cs-image_layer cs-style1">
              <Div className="cs-image_layer_in">
                <img
                  src="/images/about_img_3.jpeg"
                  alt="Why Choose Us"
                  className="w-100 cs-radius_15"
                />
              </Div>
            </Div>
            <Spacing lg="0" md="40" />
          </Div>
        </Div>
      </Div>
      {/* End Why Choose Us Section */}

      {/* Start CTA Section */}
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Cta
          title="Have a project in mind? <br />Let's <i>build</i> it together"
          btnText="Get In Touch"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
